import * as React from "react"
import Check from "../images/check.inline.svg"
import Cancel from "../images/cancel.inline.svg"
import ArrowRight from "../images/arrow-right.inline.svg"
import TelegramSvg from "../images/telegram.inline.svg"
import WhatsappSvg from "../images/whatsapp.inline.svg"

const HomeWork = ({ workRef, isWorkPlay }) => {
  // const [showFree, setShowFree] = useState(false)
  const [showBas, setShowBas] = React.useState(false)
  const [showAdv, setShowAdv] = React.useState(false)
  const [showVip, setShowVip] = React.useState(false)

  return (
    <div id="work" className="content-section" ref={workRef}>
      <div className="container">
        <div className="title-wrap-split">
          <div className="title-wrapper-left">
            <div className="title">Тарифы на марафон в зале</div>
            <h2>Все тарифы</h2>
          </div>
          <div className="marathon-link w-inline-block">
            <div className="tag">
              <div>NEW</div>
            </div>
            <div className="marathon-text-wrap">
              <div style={{ marginRight: "10px" }}>
                Марафон стартует
                <br />
                <span className="pink-span">1 февраля</span>
              </div>
              <ArrowRight className="arrow" />
            </div>
          </div>
        </div>
        <div className="w-layout-grid pricing-grid">
          <div>
            <div className="pricing-card">
              <div className="pricing-title left">
                Самостоятельный
                <br />
              </div>
              <div className="pricing-post-info left">
                <h2 className="pricing-text">
                  <strong className="price-nr">70 руб.</strong>
                </h2>
                <div>
                  <b>30</b> дней
                </div>
              </div>
              <ul className="pricing-list-table left">
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>10 тренировок</b> в зале с группой
                  </div>
                </li>
                <li className="pricing-list">
                  <Cancel className="check" />
                  <div className="pricing-list-text uncheked">
                    <b>8 тренировок</b> для дома
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Готовый</b> план питания
                  </div>
                </li>
                <li className="pricing-list">
                  <Cancel className="check" />
                  <div className="pricing-list-text uncheked">Отчеты</div>
                </li>
                <li className="pricing-list">
                  <Cancel className="check" />
                  <div className="pricing-list-text uncheked">
                    <b>Домашние</b> задания
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Общий</b> чат
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Командная</b> поддержка
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>100%</b> результ
                  </div>
                </li>
              </ul>
              <div
                className="signup-form"
                style={{
                  display: `${showBas ? "block" : "none"}`,
                }}
              >
                <div className="signup-content">
                  <p>
                    # Чтобы записаться на онлайн марафон на тариф{" "}
                    <b>"Самостоятельный"</b>, напишите сообщение с пометкой{" "}
                    <b>Самостоятельный</b>
                  </p>
                </div>
                <div className="w-layout-grid signup-links">
                  <a
                    href="https://t.me/daryia1177"
                    target="_blank"
                    rel="noreferrer"
                    className="signup-social-icon w-inline-block"
                  >
                    <TelegramSvg className="signup-social-logo" />
                    <div className="signup-social-name">Telegram</div>
                  </a>
                  <a
                    href="https://wa.me/375293944666"
                    target="_blank"
                    rel="noreferrer"
                    className="signup-social-icon w-inline-block"
                  >
                    <WhatsappSvg className="signup-social-logo" />
                    <div className="signup-social-name">WhatsApp</div>
                  </a>
                </div>
              </div>
              <button
                className="button w-button"
                onClick={() => setShowBas(!showBas)}
              >
                Записаться
              </button>
            </div>
          </div>
          <div>
            <div className="pricing-card black">
              <div className="pricing-title white left">Стандарт</div>
              <div className="pricing-post-info white left">
                <h2 className="pricing-text">
                  <strong className="price-nr white">100 руб.</strong>
                </h2>
                <div>
                  <b>30</b> дней
                </div>
              </div>
              <ul className="pricing-list-table left black">
                <li className="pricing-list white">
                  <Cancel className="check" />
                  <div className="pricing-list-text uncheked">
                    <b>2 индивидуальные</b> тренировки с тренером
                  </div>
                </li>
                <li className="pricing-list white">
                  <Cancel className="check" />
                  <div className="pricing-list-text uncheked">
                    Консультация по всем вопросам <b>24/7</b>
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>10 тренировок</b> в зале с группой
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>8 тренировок</b> для дома
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Готовый</b> план питания
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">Отчеты</div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Домашние</b> задания
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Общий</b> чат
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Командная</b> поддержка
                  </div>
                </li>
                <li className="pricing-list white">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>100%</b> результ
                  </div>
                </li>
              </ul>
              <div
                className="signup-form"
                style={{
                  display: `${showAdv ? "block" : "none"}`,
                }}
              >
                <div className="signup-content">
                  <p>
                    # Чтобы записаться на онлайн марафон на тариф{" "}
                    <b>"Стандарт"</b>, напишите сообщение с пометкой{" "}
                    <b>Стандарт</b>
                  </p>
                </div>
                <div className="w-layout-grid signup-links">
                  <a
                    href="https://t.me/daryia1177"
                    target="_blank"
                    rel="noreferrer"
                    className="signup-social-icon w-inline-block"
                  >
                    <TelegramSvg className="signup-social-logo" />
                    <div className="signup-social-name">Telegram</div>
                  </a>
                  <a
                    href="https://wa.me/375293944666"
                    target="_blank"
                    rel="noreferrer"
                    className="signup-social-icon w-inline-block"
                  >
                    <WhatsappSvg className="signup-social-logo" />
                    <div className="signup-social-name">WhatsApp</div>
                  </a>
                </div>
              </div>
              <button
                className="button w-button"
                onClick={() => setShowAdv(!showAdv)}
              >
                Записаться
              </button>
            </div>
          </div>
          <div>
            <div className="pricing-card">
              <div className="pricing-title left">Голд</div>
              <div className="pricing-post-info left">
                <h2 className="pricing-text">
                  <strong className="price-nr">150 руб.</strong>
                </h2>
                <div>
                  <b>30</b> дней
                </div>
              </div>
              <ul className="pricing-list-table left">
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>2 индивидуальные</b> тренировки с тренером
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    Консультация по всем вопросам <b>24/7</b>
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>10 тренировок</b> в зале с группой
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>8 тренировок</b> для дома
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Готовый</b> план питания
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">Отчеты</div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Домашние</b> задания
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Общий</b> чат
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>Командная</b> поддержка
                  </div>
                </li>
                <li className="pricing-list">
                  <Check className="check" />
                  <div className="pricing-list-text">
                    <b>100%</b> результ
                  </div>
                </li>
              </ul>
              <div
                className="signup-form"
                style={{
                  display: `${showVip ? "block" : "none"}`,
                }}
              >
                <div className="signup-content">
                  <p>
                    # Чтобы записаться на тариф <b>"Голд"</b>, напишите
                    сообщение с пометкой <b>Голд</b>
                  </p>
                </div>
                <div className="w-layout-grid signup-links">
                  <a
                    href="https://t.me/daryia1177"
                    target="_blank"
                    rel="noreferrer"
                    className="signup-social-icon w-inline-block"
                  >
                    <TelegramSvg className="signup-social-logo" />
                    <div className="signup-social-name">Telegram</div>
                  </a>
                  <a
                    href="https://wa.me/375293944666"
                    target="_blank"
                    rel="noreferrer"
                    className="signup-social-icon w-inline-block"
                  >
                    <WhatsappSvg className="signup-social-logo" />
                    <div className="signup-social-name">WhatsApp</div>
                  </a>
                </div>
              </div>
              <button
                className="button w-button"
                onClick={() => setShowVip(!showVip)}
              >
                Записаться
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: 470 }} className="work-bg-block"></div>
    </div>
  )
}

export default HomeWork
